import { theme } from '@miro-site/design-tokens';
var spaces = theme.spaces; //* Previously known as content

export var textSpaces = {
  afterHeadline: {
    medium: [spaces.md, spaces.lg],
    small: [spaces.sm, spaces.md],
    mid: [spaces.md],
    tiny: [spaces.md]
  }
};
export var buttonSpaces = {
  afterHeadline: {
    medium: [spaces.xl],
    small: [spaces.sm, spaces.md],
    mid: [spaces.xl]
  },
  afterText: {
    common: [spaces.xl]
  },
  afterList: {
    common: [spaces.xl]
  }
};
export var linkSpaces = {
  afterHeadline: {
    medium: [spaces.xl],
    small: [spaces.sm, spaces.md],
    mid: [spaces.xl],
    tiny: [spaces.lg]
  },
  afterButton: {
    common: [spaces.md]
  },
  afterText: {
    common: [spaces.xl]
  },
  afterList: {
    common: [spaces.xl]
  }
};
export var listSpaces = {
  afterHeadline: {
    mid: [spaces.lg]
  },
  afterText: {
    common: [spaces.lg]
  }
};